import { MY_HR_CREATE_CHANGE_REQUEST } from "my-hr/graphql";
import * as Yup from "yup";

export const placeOfBirthDialogDef = {
  type: "placeOfBirth",
  dialogLabel: "MY_HR_EDIT_PLACE_OF_BIRTH",
  mutation: MY_HR_CREATE_CHANGE_REQUEST,
  items: [
    {
      label: "OC_VALIDITY",
      name: "validFrom",
      type: "datePicker",
      validation: Yup.date().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_PLACEOFBIRTH",
      name: "placeOfBirth",
      dataField: "placeOfBirth",
      type: "text",
      validation: Yup.string()
        .trim()
        .required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "OC_MESSAGE",
      name: "initialMessage",
      type: "textarea",
      validation: Yup.string(),
    },
  ],
};
